import { render, staticRenderFns } from "./student-statistics.vue?vue&type=template&id=642f106d&scoped=true"
import script from "./student-statistics.vue?vue&type=script&lang=js"
export * from "./student-statistics.vue?vue&type=script&lang=js"
import style0 from "./student-statistics.vue?vue&type=style&index=0&id=642f106d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f106d",
  null
  
)

export default component.exports